/**
 * 读取源只允许非生产环境显式选择 Fixture。写入、发布入口必须由
 * Spring 当前身份上下文的 actions 决定，浏览器环境变量不能授予权限。
 */
export function readPriceChannelFlags(environment = process.env) {
  return Object.freeze({
    readSource:
      environment.NODE_ENV !== "production" &&
      environment.VUE_APP_PRICE_CHANNEL_READ_SOURCE === "fixture"
        ? "fixture"
        : "spring-api",
    writeEnabled: false,
    publicationEnabled: false,
  });
}

export const priceChannelFlags = readPriceChannelFlags();

/** 前端只消费服务端动作清单做展示控制；服务端仍对每次写入重新鉴权。 */
export function capabilitiesFromContext(context) {
  const actions = new Set(Array.isArray(context?.actions) ? context.actions : []);
  return Object.freeze({
    writeEnabled: actions.has("SUBMISSION_WRITE") || actions.has("CERTIFICATION_APPLY"),
    canReview: actions.has("REVIEW") || actions.has("CERTIFICATION_REVIEW") || actions.has("LEADER_REVIEW"),
    canReadOffers: actions.has("OFFER_READ"),
    canWatchlist: actions.has("WATCHLIST_WRITE"),
    // 审核权不等于发布开关；只有后端显式返回发布能力时才展示入口。
    publicationEnabled: context?.publicationEnabled === true && actions.has("REVIEW"),
  });
}
